/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import css from './EroskiHeader.style';

class EroskiHeader extends PureComponent {
  onBack = () => {
    window.history.back();
    return false;
  };

  render() {
    const { onBack } = this;
    return (
      <Fragment>
        <header className="m1">
          <div className="m1_c">
            <div className="m1_r">
              <p className="c3">
                <div role="presentation" onClick={onBack}>
                  <i className="icon-back" />
                </div>
              </p>
              <p className="c1">
                <a href="https://www.inspiracioneroski.com/">
                  <img src="https://imgs-akamai.mnstatic.com/tools/genericimages/2a5a9648cdb99fdee17071aa2b7a980be89bc664aff38184da3d9db34adb32f4.png" alt="Logo Eroski" />
                </a>
              </p>
            </div>
          </div>
        </header>
        <style type="text/css">{ css }</style>
      </Fragment>
    );
  }
}

export default EroskiHeader;
